import { Injectable } from '@angular/core';
import { AllianceDetailService } from '@account/services/alliance-detail.service';
import { retryWithDelay } from '@core/operators/retry-delay';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root',
})
export class SendEventAllianceIframe {
  messageResponse = {
    amount: '',
    term: '',
    document: '',
    reference: '',
    code: '',
  };

  constructor(private allianceDetailService: AllianceDetailService, private cookieService: CookieService) {}

  sendMessage = (code) => {
    if (sessionStorage.getItem('ac')) {
      this.messageResponse.amount = this.cookieService.get('amount') || sessionStorage.getItem('amount');
      this.messageResponse.term = this.cookieService.get('term') || sessionStorage.getItem('term');
      this.messageResponse.code = code;
      this.allianceDetailService
        .getInfoDetail({ idInfoAlliance: sessionStorage.getItem('cai'), keyList: ['docNumber', 'reference'] })
        .pipe(retryWithDelay(1000, 3))
        .subscribe({
          next: (response: Map<string, string>) => {
            if (response) {
              this.messageResponse.document = response['docNumber'];
              this.messageResponse.reference = response['reference'];
              this.encryptedResponseEvent();
            }
          },
        });
    }
  };

  public encryptedResponseEvent() {
    let resultEventEncrypt = '';
    this.allianceDetailService
      .allianceEncrypted(JSON.stringify(this.messageResponse))
      .pipe(retryWithDelay(1000, 3))
      .subscribe({
        next: (response: string) => {
          if (response != null) {
            resultEventEncrypt = response;
            window.parent.postMessage(resultEventEncrypt, '*');
          }
        },
      });
  }
}
